module.exports = __webpack_public_path__ + "static/img/coin.495d9a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/coin.png
// module id = Wo7l
// module chunks = 1